import {
  PrivacyPolicyItems,
  PrivacyPolicyItemsContent,
  PrivacyPolicyItemsTitle,
  PrivacyPolicyTitle,
  Wrapper,
} from "./style";

export const PrivacyPolicy = () => {
  return (
    <Wrapper>
      <PrivacyPolicyTitle>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</PrivacyPolicyTitle>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Область применения и согласие</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          Персональные данные физических лиц-пользователей сервиса Aviabozor.uz обрабатываются ООО «BILETONLINE», лицом,
          зарегистрированным по законодательству Республики Узбекистан, с местонахождением по адресу Республика
          Узбекистан, город Ташкент, улица Хонзодабегим, 9/1 (далее — Компания).
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          Данная Политика конфиденциальности описывает установленный Компанией порядок обработки персональных данных,
          собранных с помощью сайта Aviabozor.uz (далее — Сайт), мобильного приложения Aviabozor.uz (далее – мобильное
          приложение) и связанных с ними услуг и инструментов. Во всех указанных случаях Компания обрабатывает
          персональные данные пользователей исключительно в рамках требований Законов Республики Узбекистан и Конвенции
          о защите лиц в связи с автоматизированной обработкой персональных данных.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          Используя Сайт, и/или мобильное приложение, и/или иные связанные сервисы и инструменты Aviabozor.uz,
          Пользователь предоставляет своё согласие Компании на обработку своих персональных данных, таких как имя
          пользователя, регион проживания, адрес электронной почты, контактный телефон, другая контактная информация;
          ip-адреса, другие коммуникационные данные пользователей; сообщения, письма, заявления, передаваемые
          пользователю другими пользователями и наоборот, а также даёт своё согласие на передачу своих персональных
          данных третьим лицам.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          Пользователи должны знать, что при переходе на некоторые ссылки, размещённые на Сайте или в мобильном
          приложении, они могут быть перенаправлены к сайтам других компаний, где информация о Пользователях собирается
          вне прямого контроля Компании.
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Информация, которую собирает, получает и размещает компания</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          <strong>Информация об учетной записи:</strong>
          <ol>
            <li>
              Для создания учетной записи Пользователю необходимо указать свой номер телефона и ввести полученный
              sms-код.
            </li>
            <li>
              Учетная запись включает в себя номер телефона, географическое расположение, имя, действительный адрес
              электронной почты и сопутствующую информацию, в том числе фотографии.
            </li>
            <li>
              Учетная запись позволяет Пользователям связываться друг с другом, чтобы выразить заинтересованность в
              своих предложениях.
            </li>
            <li>
              Пользователи несут ответственность за всю информацию, размещаемую ими в общедоступных учетных записях.
            </li>
            <li>
              Пользователь должен внимательно рассмотреть все риски, связанные с тем, что он делает определённую
              информацию — в частности, номер телефона и географическое расположение — общедоступной.
            </li>
          </ol>
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          <strong>Объявления и Сделки.</strong> В рамках деятельности своего сайта, Компания может размещать информацию,
          в том числе личного и контактного характера, необходимую для совершения сделок между покупателем и продавцом.
          Пользователи несут ответственность за всю информацию, размещаемую ими на сайте.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          <strong>Реклама и Продвижение.</strong> В рамках деятельности своего сайта, Компания может обрабатывать
          информацию, связанную с эффективностью рекламных кампаний, в том числе, какие объявления были просмотрены на
          Сайте или на сайтах третьих лиц.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          <strong>Обслуживание клиентов.</strong> При обращении Пользователей в отдел обслуживания клиентов, Компания
          может собирать личную информацию, необходимую для выполнения запроса Пользователя. Компания может также
          собирать другую информацию об общении с Пользователями.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          <strong>Веб-сайт и мобильные данные.</strong> Компания может автоматически получать и регистрировать на своих
          серверах информацию из браузера пользователя или любого устройства, включая IP-адрес, программного обеспечения
          и аппаратные атрибуты, страницы, которые запрашивает Пользователь.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          Компания не собирает и не обрабатывает информацию о расовом или этническом происхождении, политических,
          религиозных или мировоззренческих убеждениях, членстве в политических партиях и профессиональных союзах.
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>IP-адрес, cookies и мобильные идентификаторы</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          В рамках деятельности своего сайта, Компания может собирать определенную информацию с помощью таких технологий
          как cookies, пиксели (pixels), и локального хранилища. Пиксели (pixels) — небольшие цифровые изображения,
          которые являются частью кодов на веб-страницах и позволяют другому серверу измерить просматриваемость
          веб-страницы.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          С помощью cookies, веб-сервер может сохранить предпочтения и настройки на устройстве Пользователя, которое
          затем автоматически восстанавливается при следующем посещении. Компания использует как постоянные, так и
          сессионные куки.
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Использование персональных данных</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          Компания может использовать информацию для следующих целей:
          <ul>
            <li>предоставлять пользователям возможность пользоваться услугами Компании;</li>
            <li>обеспечивать стабильную работу и безопасность Сайта, улучшать пользовательский опыт;</li>
            <li>предупреждать и пресекать нарушения законодательства;</li>
            <li>отвечать на обращения пользователей;</li>
            <li>выполнять обязанности, предусмотренные законодательством;</li>
            <li>направлять маркетинговые сообщения о продуктах Компании и её партнеров;</li>
            <li>организовывать участие пользователей в мероприятиях, исследованиях и опросах.</li>
          </ul>
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Обмен информацией</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          Компания может делиться информацией с аффилированными лицами. Компания может использовать сторонних
          поставщиков услуг для предоставления некоторых составляющих своих услуг. Компания может предоставлять
          персональные данные пользователей на запросы компетентных органов, оформленных в соответствии с требованиями
          законодательства Республики Узбекистан. Компания обязуется не передавать в аренду и не продавать любые
          персональные данные Пользователя.
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Пользовательский контроль</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          <strong>Доступ, Исправление и Удаление.</strong> Пользователи, которые создали учётную запись, могут получать
          доступ, исправлять или удалять информацию, которую они предоставляют. Размещенная информация может быть
          изменена или удалена в личном кабинете пользователя. Пользователь может полностью удалить свою учетную запись,
          обратившись в техподдержку.
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          <strong>Cookies.</strong> Большинство основных браузеров обеспечивают элементы управления, которые позволяют
          пользователю ограничить или заблокировать установку Cookies на ваших системах. Обратите внимание, что
          отключение Cookies может привести к ограниченной функциональности веб-сайтов.
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Безопасность</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          Вся информация, которую собирает Компания, в разумных пределах защищена техническими средствами и процедурами
          обеспечения безопасности в целях предотвращения несанкционированного доступа или использования данных.
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Внесение изменений в Политику Конфиденциальности</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>
          Компания может обновлять эту политику конфиденциальности время от времени. Действующая редакция Политики
          конфиденциальности всегда находится на странице по адресу{" "}
          <a href="https://aviabozor.uz/privacy-policy-info" target="_blank" rel="noreferrer">
            https://aviabozor.uz/privacy-policy-info
          </a>
        </PrivacyPolicyItemsContent>

        <PrivacyPolicyItemsContent>
          В случае если Компанией были внесены любые изменения в Политику Конфиденциальности, с которыми Пользователь не
          согласен, он обязан прекратить использование сервисов Сайта. Факт не прекращения использования Сайта является
          подтверждением согласия Пользователя.
        </PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>

      <PrivacyPolicyItems>
        <PrivacyPolicyItemsTitle>Контакты</PrivacyPolicyItemsTitle>

        <PrivacyPolicyItemsContent>Юридический адрес: город Ташкент, улица Нукус, дом 88/1</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>
          Адрес местонахождения: город Ташкент, ул. Хонзодабегим, дом 9/1
        </PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>ИНН: 306628565</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Дата регистрации: 07.08.2019 г.</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Регистрирующий орган: Центр государственных услуг</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Код ОПФ: 152</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Код ОКЭД: 52230</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Код СООГУ: 79994</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Код СОАТО: 1726273 – г. Ташкент, Мирабадский район</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Регистрационный номер НДС: 326010207298</PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>
          Тел.: <a href="tel:+998885979009">+998885979009</a>; <a href="tel:+998772979009">+998772979009</a>
        </PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>
          E-mail: <a href="mailto:ticket@aviabozor.uz">ticket@aviabozor.uz</a>
        </PrivacyPolicyItemsContent>
        <PrivacyPolicyItemsContent>Директор Тюшагин Владимир Иванович</PrivacyPolicyItemsContent>
      </PrivacyPolicyItems>
    </Wrapper>
  );
};
